import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "facet-range" }





export default /*@__PURE__*/_defineComponent({
  __name: 'range-selector',
  props: {
    value: {}
  },
  emits: ["update-range"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

const change = (value: any) => {
  emit("update-range", value);
};

return (_ctx: any,_cache: any) => {
  const _component_ElTag = _resolveComponent("ElTag")!
  const _component_ElSlider = _resolveComponent("ElSlider")!
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")!
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")!
  const _component_ElDropdown = _resolveComponent("ElDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ElDropdown, {
      placement: "bottom-start",
      "hide-on-click": false
    }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_ElDropdownMenu, null, {
          default: _withCtx(() => [
            _createVNode(_component_ElDropdownItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_ElSlider, {
                  "model-value": props.value,
                  max: 6,
                  min: 1,
                  step: 1,
                  range: "",
                  "show-stops": "",
                  marks: {
                1: '1',
                2: '2',
                3: '3',
                4: '4',
                5: '5',
                6: '6',
              },
                  onInput: change
                }, null, 8, ["model-value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_ElTag, {
          type: "primary",
          effect: "plain"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("VIL (level)", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})